import applicant from './applicant';

const employee = function () {
    applicant();
}

export default employee;